import { FaPlus } from 'react-icons/fa'
import { useQuery } from 'jsonapi-react'

import { Events } from 'components/Events'
import { ActionButton, ActionButtonsGroup } from 'layouts/basic'
import { useHistory } from 'react-router'
import { AccounHeader } from 'scenes/account/AccountMainMenu'
import { Body } from 'layouts/basic'


export default function SceneEvents(props) {
  const history = useHistory()

  const { data: events = [], isLoading } = useQuery([
    'events',
    'mine',
    {
      include: 'created_by,image',
      sort: '-created_at',
    }
  ])

  return (
    <>
      <AccounHeader />
      <Body loading={isLoading}>
        <Events
          loading={isLoading}
          dateClassName='top-12 sm:top-16'
          items={events}
        />
        <ActionButtonsGroup>
          <ActionButton
            onClick={() => history.push(props.match.path + '/new')}
          >
            <FaPlus />
          </ActionButton>
        </ActionButtonsGroup>
      </Body>
    </>
  )
}
